import { IEnvironment } from './environment.interface';
export const environment: IEnvironment = {
  api: 'https://api-staging.mymarchon.com',
  cmsHost: 'https://cdn-acpt.vsp.com/',
  oAuth: {
    acsBaseUrl: 'https://api-staging.mymarchon.com',
    clientId: 'efkscopestatusspa-dev',
    scopes:
      'auth_employee_sso write:mar.customermarketingprograms read:mar.customermarketingprograms read:mar.organizationservices read:mar.customerservices read:mar.esbcustomergetcustomerlistweb read:mar.proc-kaleyedoscope-api write:mar.proc-kaleyedoscope-api',
    redirectUrl: 'https://efkscopestatus-stg.pub.marchon.com',
  },
  muleHost: 'https://api-dev.pub.vsp.com'
};
